
<filterbox [(ngModel)]="filter" (ngModelChange)="onFilterChange()"></filterbox>
<entity-list *ngIf="!loading || tags.length" [entities]="tags" className="list-group list-group-light">
  <ng-template entityListItem let-tag="entity">
    <div class="list-group-item combi single w-100" data-test-qa="tag">
      <div class="list-group-main d-flex align-items-center mr-auto">
        <media-tag [tag]="tag"></media-tag>
      </div>
      <button class="btn btn-link reveal m-0" (click)="addTag.emit(tag)" data-test-qa="addTag"><i class="far fa-check"></i>
        <translate>Add</translate>
      </button>
      <button class="btn btn-link reveal m-0" (click)="removeTag.emit(tag)" data-test-qa="removeTag"><i class="far fa-times"></i>
        <translate>Remove</translate>
      </button>
    </div>
  </ng-template>
</entity-list>
<spinner *ngIf="loading"></spinner>
<button class="btn btn-secondary btn-block" (click)="loadMore()" *ngIf="moreAvailable" [disabled]="loading"><i class="far fa-fw fa-ellipsis-h" *ngIf="!loading"></i><i class="far fa-fw fa-circle-notch fa-spin" *ngIf="loading"></i>
  <translate>More tags</translate>
</button>
<add-object-form (submitted)="createTag($event)" [placeholder]="'New tag'|translate" data-test-qa="newTag"></add-object-form>